/**
 * Created by razial on 15.09.2025.
 */

cleverapps.override(cleverapps.Tool, {
    UI: {
        windows: {
            islandDecorationWindow: displayToolWindow(() => {
                const mission = new Mission(Mission.TYPE_ISLAND_DECORATION);

                new IslandDecorationWindow(mission);
            }),

            IslandPreviewWindow: displayToolWindow(() => {
                const mission = new Mission(Mission.TYPE_ISLAND_DECORATION);
                mission.logic.stage = 1000;

                new IslandPreviewWindow(mission);
            })
        }
    }
});

(function () {
    const original = MissionsTool.getMissionMenu;

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (mission.type !== Mission.TYPE_ISLAND_DECORATION) {
            return actions;
        }

        actions.addStars = function () {
            displayToolPrompt((value) => {
                const stars = parseInt(value);
                if (Number.isFinite(stars)) {
                    mission.update(stars);
                }
            }, "Enter number of stars", 5000);
        };

        return actions;
    };
}());

cleverapps.Tool.islandDecoration = ToolFolder.create(() => {
    const startSeason = function (shift) {
        const mission = cleverapps.missionManager.findByType(Mission.TYPE_ISLAND_DECORATION);
        if (mission) {
            cleverapps.missionManager.remove(mission);
        }

        DateShift.setShift(shift);

        if (!IslandDecorationConfig.getPeriod()) {
            return;
        }

        cleverapps.missionManager.planMission(Mission.TYPE_ISLAND_DECORATION);

        cleverapps.focusManager.whenFreeFocus(() => {
            cleverapps.placements.run(Placements.FREE_FOCUS, {
                skipDelayFromStart: true
            });
        });
    };

    const seasons = {};

    cleverapps.eventManager.listFeatureEvents("island_decoration").filter((event) => !event.tool).forEach((event) => {
        seasons[IslandDecorationHelper.getString(event.options.period, "start")] = () => {
            startSeason(event.start.getTime() - DateShift.Date.now());
        };
    });

    seasons.resetToNow = () => {
        startSeason(0);
    };

    return seasons;
});
